// Export a component that will use a cloudwatch logger to log messages to the console, then we will add <Elextron /> to our app.tsx file
import { useEffect } from 'react'
import useCloudwatchLogger from '~/hooks/useCloudwatchLogger'
import { isElectron } from '~/utils/common'

export function ElectronLogger() {
  const { logger } = useCloudwatchLogger('Electron')

  useEffect(() => {
    if (!isElectron) return

    logger?.info('⚡️ Setting up listener for electron logs')
    window.electron?.receive('electron-log', (message: string) => {
      logger?.info(message)
    })
    logger?.info('⚡️ Listener for electron logs set up')

    // Cleanup listener on unmount
    return () => {
      logger?.info('⚡️ Removing listener for electron logs')
      window.electron?.removeAllListeners('electron-log')
    }
  }, [])

  // This component doesn't render anything
  return null
}
